<main>
  <div class="container" id="main-container">
    <div class="row">
      <div class="col px-lg-4">
        <app-breadcrumbs [path]="data?.path?.alias"></app-breadcrumbs>
      </div>
    </div>
    <div class="row" *ngIf="data.moderation_state == 'archived'">
      <div class="col px-lg-4">
        <div class="callout danger">
          <div class="callout-inner">
            <div class="callout-title">
              <svg class="icon">
                <use href="/bootstrap-italia/dist/svg/sprites.svg#it-info-circle"></use>
              </svg>
              <span class="visually-hidden">Note</span>
              <span class="text">Contenuto archiviato</span>
            </div>
            <p><span class="node__archived_text">Contenuto archiviato per fini storici di documentazione.</span></p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8 px-lg-4 py-lg-2">
        <h1 data-audio="">
          {{ data.title }}
        </h1>
        <h2 class="visually-hidden">Dettagli della notizia</h2>
        <p data-audio="">
          {{ data.news_description }}
        </p>
        <div class="row mt-5 mb-4">
          <div class="col-6">
            <small>Data:</small>
            <p class="fw-semibold font-monospace">{{ data.created | date }}</p>
          </div>
          <div class="col-6">
            <small>Tempo di lettura:</small>
            <p class="fw-semibold">1 min</p>
          </div>
        </div>
      </div>

      <div class="col-lg-3 offset-lg-1">
        <app-social-share [url]="data?.path?.alias"></app-social-share>
        <app-actions-list
          [mailObject]="data?.title"
          [path]="data?.path?.alias"
        ></app-actions-list>
        <div class="mt-4 mb-4" *ngIf="data?.news_tags?.length > 0">
          <div class="row">
            <span class="mb-2 small">Argomenti</span>
          </div>
          <ul class="d-flex flex-wrap gap-1">
            <li *ngFor="let tag of data.news_tags">
              <a class="chip chip-simple" [href]="tag?.path?.alias">
                <span class="chip-label">{{ tag.title }}</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="mt-4 mb-4" *ngIf="data?.news_objectives?.length > 0">
          <div class="row">
            <span class="mb-2 small"
              ><i
                >Questo contenuto contribuisce agli obiettivi di sviluppo
                sostenibile:</i
              ></span
            >
          </div>
          <ul class="d-flex flex-wrap gap-1">
            <li *ngFor="let objective of data.news_objectives">
              <img
                [src]="objective?.field_icona?.uri?.url"
                [title]="objective.name"
                [alt]="objective.name"
                class="icon icon-lg"
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid my-3" *ngIf="data.field_internal_image?.field_media_image">
    <div class="row">
      <figure class="figure px-0 img-full">
        <img
          [src]="data.field_internal_image?.field_media_image?.uri?.url"
          class="figure-img img-fluid"
          [alt]="data.field_internal_image?.field_media_image?.meta?.alt"
        />
        <figcaption class="figure-caption text-center pt-3">
          {{ data.field_internal_image?.field_media_image?.meta?.title }} <span *ngIf="data?.field_internal_image?.field_media_licence"> - {{data.field_internal_image?.field_media_licence}}</span>
        </figcaption>
      </figure>
    </div>
  </div>
  <div class="container">
    <div
      class="row border-top border-light row-column-border row-column-menu-left"
    >
      <aside class="col-lg-3">
        <div
          class="cmp-navscroll sticky-top"
          aria-labelledby="accordion-title-one"
        >
          <nav
            class="navbar it-navscroll-wrapper navbar-expand-lg"
            aria-label="INDICE DELLA PAGINA"
            data-bs-navscroll=""
          >
            <div class="navbar-custom" id="navbarNavProgress">
              <div class="menu-wrapper">
                <div class="link-list-wrapper">
                  <div class="accordion">
                    <div class="accordion-item">
                      <span class="accordion-header" id="accordion-title-one">
                        <button
                          class="accordion-button pb-10 px-3"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse-one"
                          aria-expanded="true"
                          aria-controls="collapse-one"
                        >
                          INDICE DELLA PAGINA
                          <svg class="icon icon-xs right">
                            <use
                              href="bootstrap-italia/dist/svg/sprites.svg#it-expand"
                            ></use>
                          </svg>
                        </button>
                      </span>
                      <div class="progress">
                        <div
                          class="progress-bar it-navscroll-progressbar"
                          role="progressbar"
                          aria-valuenow="0"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          style="width: 0%"
                        ></div>
                      </div>
                      <div
                        id="collapse-one"
                        class="accordion-collapse collapse show"
                        role="region"
                        aria-labelledby="accordion-title-one"
                      >
                        <div class="accordion-body">
                          <ul class="link-list" data-element="page-index">
                            <li class="nav-item">
                              <a
                                class="nav-link active"
                                href="javascript:void(0);"
                                data-focus-mouse="false"
                                (click)="scrollTo('descrizione')"
                              >
                                <span class="title-medium">Descrizione</span>
                              </a>
                            </li>
                            <li class="nav-item" *ngIf="data?.news_responsible?.length > 0">
                              <a
                                class="nav-link"
                                href="javascript:void(0);"
                                data-focus-mouse="false"
                                (click)="scrollTo('a-cura-di')"
                              >
                                <span class="title-medium">A cura di</span>
                              </a>
                            </li>
                            <ng-container *ngFor="let link of links">
                              <li class="nav-item">
                                <a
                                  class="nav-link"
                                  href="javascript:void(0);"
                                  data-focus-mouse="false"
                                  (click)="scrollTo(link.url)"
                                >
                                  <span class="title-medium">{{
                                    link.title
                                  }}</span>
                                </a>
                              </li>
                            </ng-container>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </aside>
      <section class="col-lg-9 it-page-sections-container border-light">
        <article
          id="descrizione"
          class="it-page-section anchor-offset richtext-wrapper"
          data-audio=""
          [innerHTML]="data.news_body?.processed || '' | safeHtml"
        ></article>
        <article id="a-cura-di" class="it-page-section anchor-offset mt-5"  *ngIf="data?.news_responsible?.length > 0">
          <h2 class="mb-3">A cura di</h2>
          <div class="row">
            <div class="col-12 col-sm-8 col-xl-6" *ngFor="let org_unit of data?.news_responsible">
              <div class="card-wrapper rounded shadow-sm h-auto" >
                <div class="card card-teaser card-teaser-info rounded shadow-sm p-3">
                <div class="card-body pe-3">
                  <p class="card-title text-paragraph-regular-medium-semi mb-3">
                    <a [title]="org_unit.title" class="text-decoration-none"
                      [href]="org_unit?.path?.alias">
                      {{ org_unit.title }}
                    </a>
                  </p>
                  <div class="card-text">
                    <p class="card-text" [innerHTML]="
                        stringSubstr(org_unit?.org_unit_short_description, 0, 255)
                  "></p>
                  </div>
                </div>
                <div class="avatar size-xl" *ngIf="org_unit?.org_unit_image?.field_media_image">
                  <img [src]="org_unit?.org_unit_image?.field_media_image?.uri?.url"
                    [alt]="org_unit?.org_unit_image?.field_media_image?.meta?.alt" />
                </div>
              </div>
            </div>
          </div>
          </div>
        </article>
      </section>
    </div>
  </div>
</main>
